import { Dialog } from 'radix-ui'
import { X } from 'lucide-react'
import { useUIStore } from './ui-store'
import { SidebarContent } from './sidebar-content'
export function NavigationDrawer({
  dashboard = false,
  pos = false,
}: {
  dashboard?: boolean
  pos?: boolean
}) {
  const open = useUIStore((s) => s.drawerOpen)
  const setOpen = useUIStore((s) => s.setDrawerOpen)
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="drawer-overlay" />
        <Dialog.Content
          className={`drawer-content ${dashboard ? 'pharmacy-drawer' : ''}`}
          aria-describedby={undefined}
          onCloseAutoFocus={(event) => {
            event.preventDefault()
            document.getElementById('mobile-menu-trigger')?.focus()
          }}
        >
          <Dialog.Title className="sr-only">เมนูนำทาง</Dialog.Title>
          <Dialog.Close className="drawer-close" aria-label="ปิดเมนู">
            <X size={20} />
          </Dialog.Close>
          <SidebarContent dashboard={dashboard} pos={pos} />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
